module.exports = __webpack_public_path__ + "static/media/instagram-verification-badge.57b161ec.svg";